import React from 'react';
import Cross from '../../icons/Cross';
import Ripple from '../Ripple';
import Popup from './A';


module.exports = (props) => {
  const {
    onCancel,
  } = props;
  return (
    <Popup className={'w1030' + (props.className ? ` ${props.className}` : '')}>
      <div className="layoutRow fhaS fvaC">
        <div className="f23 fw7 lh fx1 wmin0">
          {props.caption || ''}
        </div>
        {onCancel ? (
          <div className="pl15 mv-10 mr-15">
            <Ripple
              className="layoutRow fhaC fvaC h40 ph15 fw4 f12 lts0em lh ttU
                c5B47FF dn c7B67FF:h olN tdN r5 ov"
              onClick={onCancel}
            >
              <div className="layoutRow fhaC fvaC rlv st1">
                <div>Cancel</div>
                <Cross className="ml10 w10 c5B47FF"/>
              </div>
            </Ripple>
          </div>
        ) : null}
      </div>
      {props.children}
    </Popup>
  );
};
